import { styled, Dialog, Card } from '@mui/material';
export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    maxWidth: '1000px',
    width: '95vw',
    maxHeight: '90vh',
  },
}));

export const StyledItem = styled(Card)(() => ({ marginBottom: '8px', display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', alignItems: 'center' }));